'use client';

import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';

import GoogleAnalyticsWrapper from '@/components/GoogleAnalyticsWrapper';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasConsented, setHasConsented] = useState<boolean | null>(null); // Explicitly typing as boolean or null

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (consent === null || consent === 'false') {
      setIsVisible(true);
    }
    setHasConsented(consent === 'true');
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setHasConsented(true); // Now correctly set as a boolean
    setIsVisible(false);
    window.location.reload(); // Reload to apply Google Analytics immediately
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'false');
    setHasConsented(false); // Now correctly set as a boolean
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 50, opacity: 0 }}
          transition={{ duration: 0.4, ease: 'easeOut' }}
          className="fixed bottom-4 left-1/2 -translate-x-1/2 w-full max-w-xl bg-white/80 backdrop-blur-lg shadow-lg rounded-2xl p-5 text-gray-800 flex flex-col sm:flex-row justify-between items-center border border-gray-300"
        >
          <div className="text-sm sm:text-base text-center sm:text-left">
            🍪 We use cookies to enhance your experience. Read our{' '}
            <a href="/cookies" className="text-primary hover:underline">
              Cookie Policy
            </a>
            ,{' '}
            <a href="/privacy" className="text-primary hover:underline">
              Privacy Policy
            </a>{' '}
            and{' '}
            <a href="/terms" className="text-primary hover:underline">
              Terms of Use
            </a>
            .
          </div>
          <div className="mt-3 sm:mt-0 flex space-x-3">
            <button
              className="px-4 py-2 text-sm font-medium bg-primary text-white rounded-lg hover:brightness-90 transition-all"
              onClick={handleAccept}
            >
              Accept
            </button>
            <button
              className="px-4 py-2 text-sm font-medium bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400 transition-all"
              onClick={handleReject}
            >
              Reject
            </button>
          </div>
        </motion.div>
      )}

      {hasConsented && (
        <GoogleAnalyticsWrapper
          measurementId={process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID || ''}
        />
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
